export const EnglishStrings = {
    language: "Language",
    settings: "Settings",
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    places: "Places",
    updating: "Updating...",
    addingPlace: "Add New Place",
    manual: 'Manual',
    receive: 'Receive',
    roomName: 'Room Name:',
    add: 'Add',
    cancel: 'Cancel',
    fetchingReceiveCode: 'Fetching Receive Code...',
    enterThisCodeToGetPlaces: 'Enter this code to get place(s)',
    anErrorOccurredPleaseCheckInternetConnection: "An error occurred, Please check your internet connection",
    error: 'error',
    ok: 'OK',
    pleaseEnterRoomName: 'Please Enter Room Name.',
    pleaseEnterTargetUserCode: "Please Enter Target User Code",
    selectedRoomsSentSuccessfully: "Selected rooms sent successfully",
    userWithProvidedCodeDidNotFound: "User with provided code did NOT found.",
    receivePlace: 'Fetch Room',
    logOut: 'Log out',
    update: 'Update',
    anErrorOccurredWhileConnectingToDevicePleaseTryAgain: 'An error occurred while connecting to device, Please try again.',
    pleaseEnterRequestedInformations: 'Please enter requseted informations.',
    dataSusseccfullySentToDevicePleaseCloseAppAndConnectToInternet: 'Data Successfully sent to device. Please close application and connect to internet. Disappearing ZITCO_CONFIG is sign of compelete setup.',
    anErrorOccurredPleaseEnsureThatYouAreConnectedToDeviceNetwork: 'An Error occurred, Please Ensure thet you are connected to device WiFi network',
    errorInSocketConnection: 'Error in socket connection',
    deviceConfigurationIsNotPossibleWithWebApplication: 'Device configuration is not possible with web application',
    pleaseTurnOnLocationService: "Please Turn on location service",
    permissionDenied: "Permission Denied",
    plug: 'Plug',
    AC: 'A/C',
    switch: 'Switch',
    connecting:'Connecting...',
    addDevice: 'Add Device',
    putDeviceOnConfigMode: 'First, Put device on configuration mode.(The LED should be blinking)',
    nextStep: 'Next',
    connectZITCOCONFIGThroughtWifi: 'Connect ZITCO_CONFIG through WiFi',
    password: '(Password:123456789)',
    chooseNetworkAndEnterItsPassword: 'Choose Network name and enter password',
    placeholderPassword: 'Password',
    chooseNetwork:  "Choose Network..." ,
    search: 'Search',
    saveModemInfo:'Save modem data',
    addingDevice: 'Adding Device...',
    addDevice: 'Add Device',
    edit: 'Edit',
    deny: 'Cancel',
    save: 'Save',
    signIn: 'Sign In',
    enterYourPhoneNumber: 'Enter Your Phone number',
    phoneNumber: 'Phone Number:',
    sendCode: 'Send Code',
    serverInternalError: 'Server Internal Error',
    textMessage: 'Text Message',
    activationWithTextMessage:'Activation With Text Message',
    activationCode: 'Activation Code:',
    activationCodeSuccessfullySentTo: 'Activation Code Successfully sent To:',
    wrongCode: 'Entered code is incorrect',
    back: 'Back',
    offlineConfig: 'Activate through offline usage',
    home: 'Home',
    senarios: 'Senarios',
    addSenario: 'افزودن سناریو',
    senarioName: 'نام سناریو',
    pleaseUseAnUsedName: "لطفا نام غیر تکراری انتخاب کنید.",
    pleaseChooseASenarioName: 'لظفا یک نام برای سناریو انتخاب کنید.',
    thisSenarioNameAlreadyUsed: 'این نام برای سناریو دیگری انتخاب شده است، لطفا نام غیرتکراری وارد کنید.',
    delete: 'حذف',
    share: 'اشتراک گذاری',
    offlineUsage: 'کاربری آفلاین',
    toUseOfflineUsageYouShouldEnableWifi: 'برای استفاده از حالت آفلاین باید شبکه وای فای روشن باشد. (شما میتوانید تنظیمات مربوط به کاربری آفلاین را در صفحه تنظیمات تغییر دهید.)',
    requestForWifiPermission: 'درخواست دسترسی به فای وای',
    ZitkitNeedsThisPermissionToConnectToYourSmartSwitch: 'زیت کیت برای اتصال خودکار به کلید هوشمند نیاز به این دسترسی دارد.',
    notNow: 'فعلا نه',
    notAllowed: 'مجاز نیست',
    Allowed: 'مجاز است',
    searchForOfflineModule: 'جست و جو',
    toYouOfflineUsageYouShouldTurnOfflineUsageOnInSettings: 'برای استفاده از حالت کاربری آفلاین باید کاربری آفلاین را در تنظیمات فعال کنید.',
    termsAndPolices: 'قوانین',
    readTermsAndPolicies: 'مطالعه قوانین و شرایط استفاده',


}